import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useChatService from '../../../app/services/hooks/useChatService';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';
import ChatDocumentForm from './forms/ChatDocumentForm';
import { AppContext } from '../../../contexts/AppContext';

interface Props {
    onSaved: () => void;
    onCancel: () => void;
    onError: () => void;
}

const ChatDocumentCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { storeDocument, fetchingStoreDocument } = useChatService();
    const { fieldErrorMessage, onFocusRemove, setErrors } = useHandleErrorFields();
    
    const [form, setForm] = useState({
        name: '',
        description: '',
        category: 'other',
        file: null as File | null
    });

    const handleInputChange = (field: string) => (value: any) => {
        setForm({ ...form, [field]: value });
    };

    const handleFileChange = (file: File | null) => {
        setForm({ ...form, file });
    };

    const handleSubmit = () => {
        if (!form.file) {
            toast.error('Debe seleccionar un archivo.');
            return;
        }

        const formData = new FormData();
        formData.append('name', form.name);
        formData.append('description', form.description);
        formData.append('category', form.category);
        formData.append('file', form.file);

        if (showLoading) showLoading('loading', 'Subiendo documento...');

        storeDocument(formData, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message);
                setErrors({});
                onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                onError();
            },
            onFieldError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrors(response.data);
                toast.error('Por favor corrige los errores en el formulario.');
            }
        });
    };

    return (
        <ChatDocumentForm
            form={form}
            handleInputChange={handleInputChange}
            handleFileChange={handleFileChange}
            handleSubmit={handleSubmit}
            onCancel={onCancel}
            loading={fetchingStoreDocument}
            fieldErrorMessage={fieldErrorMessage}
            onFocusRemove={onFocusRemove}
            isEdit={false}
        />
    );
};

export default ChatDocumentCreate;

